import { ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal } from '@angular/core';

export type SzSkeletonShape = 'block' | 'text' | 'circle';

@Component({
  selector: 'sz-skeleton',
  templateUrl: './sz-skeleton.component.html',
  styleUrls: ['./sz-skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class SzSkeletonComponent {
  readonly shape: InputSignal<SzSkeletonShape> = input<SzSkeletonShape>('block');
  readonly width: InputSignal<string | null> = input<string | null>(null);
  readonly height: InputSignal<string | null> = input<string | null>(null);
  readonly radius: InputSignal<string | null> = input<string | null>(null);

  readonly inlineStyle: Signal<Record<string, string>> = computed(() => {
    const style: Record<string, string> = {};
    const w: string | null = this.width();
    const h: string | null = this.height();
    const r: string | null = this.radius();
    if (w !== null) {
      style['width'] = w;
    }
    if (h !== null) {
      style['height'] = h;
    }
    if (r !== null) {
      style['border-radius'] = r;
    }
    return style;
  });
}
